export const DEFAULT_SHORT_CACHE_TIME = 60 * 1000 * 60 * 6; // 6 hours cache time
export const DEFAULT_SHORT_CACHE = {
  gcTime: DEFAULT_SHORT_CACHE_TIME,
  staleTime: DEFAULT_SHORT_CACHE_TIME,
};

export const DEFAULT_CACHE_TIME = 60 * 1000 * 60 * 24; // 24 hours cache time
export const DEFAULT_CACHE = {
  gcTime: DEFAULT_CACHE_TIME,
  staleTime: DEFAULT_CACHE_TIME,
};
